import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import QuemSomosPreview from './components/QuemSomosPreview';
import Services from './components/Services';
import Solutions from './components/Solutions';
import Segments from './components/Segments';
import Clients from './components/Clients';
import Contact from './components/Contact';
import Footer from './components/Footer';
import DesenvolvimentoSistemas from './pages/DesenvolvimentoSistemas';
import CriacaoSites from './pages/CriacaoSites';
import Prototipacao from './pages/Prototipacao';
import Consultorias from './pages/Consultorias';
import QuemSomosPage from './pages/QuemSomosPage';
import ScrollToTop from './ScrollToTop';
import PoliticaPrivacidade from './pages/PoliticaPrivacidade';
import TermosUso from './pages/TermosUso';
import { HelmetProvider } from 'react-helmet-async';

function HomePage() {
  return (
    <>
      <Hero />
      <Services />
      <Solutions />
      <QuemSomosPreview />
      <Segments />
      <Clients />
      <Contact />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/quem-somos" element={<QuemSomosPage />} />
            <Route path="/servicos/desenvolvimento-sistemas" element={<DesenvolvimentoSistemas />} />
            <Route path="/servicos/criacao-sites" element={<CriacaoSites />} />
            <Route path="/servicos/prototipacao" element={<Prototipacao />} />
            <Route path="/servicos/consultorias" element={<Consultorias />} />
            <Route path="/politica-privacidade" element={<PoliticaPrivacidade />} />
            <Route path="/termos-uso" element={<TermosUso />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App; 